import React, { useContext, useEffect } from 'react';
import { MobileContext } from '../Context';
import DesktopLayout from './_partials/DesktopLayout';
import MobileLayout from './_partials/MobileLayout';
import EmptyState from './_partials/EmptyState';
import { useAddToGroupFlow } from './useAddToGroupFlow';
var AddToGroupsPanel = function (_a) {
    var dismissGroupsPanel = _a.dismissGroupsPanel, deviation = _a.deviation, addToGroupFolder = _a.addToGroupFolder, initGroupsPanel = _a.initGroupsPanel, isEmpty = _a.isEmpty;
    var isMobile = useContext(MobileContext);
    var _b = useAddToGroupFlow(), selectedGroup = _b.selectedGroup, selectedSubmissionType = _b.selectedSubmissionType, selectGroup = _b.selectGroup, resetSelectedGroup = _b.resetSelectedGroup, selectSubmissionType = _b.selectSubmissionType;
    useEffect(function () {
        initGroupsPanel();
    }, [initGroupsPanel]);
    if (isEmpty) {
        return React.createElement(EmptyState, null);
    }
    var selectFolder = selectedGroup
        ? function (folderId) {
            addToGroupFolder(deviation, selectedGroup, {
                groupId: selectedGroup.userId,
                folderId: folderId,
                type: selectedSubmissionType,
            });
        }
        : function () { return null; };
    if (isMobile) {
        return (React.createElement(MobileLayout, { deviationId: deviation.deviationId, selectedGroup: selectedGroup, selectedSubmissionType: selectedSubmissionType, onResetSelectedGroup: resetSelectedGroup, onGroupSelected: selectGroup, onSubmissionTypeSelected: selectSubmissionType, onFolderSelected: selectFolder, onClose: dismissGroupsPanel }));
    }
    return (React.createElement(DesktopLayout, { deviationId: deviation.deviationId, selectedGroup: selectedGroup, selectedSubmissionType: selectedSubmissionType, onResetSelectedGroup: resetSelectedGroup, onGroupSelected: selectGroup, onSubmissionTypeSelected: selectSubmissionType, onFolderSelected: selectFolder }));
};
AddToGroupsPanel.displayName = 'AddToGroupsPanel';
export default AddToGroupsPanel;
//# sourceMappingURL=AddToGroupsPanel.js.map